import { CUSTOM_HEADER_ERROR_MESSAGES, MAX_HEADER_KEY_LENGTH, MAX_HEADER_VALUE_LENGTH, RESERVED_HEADERS } from "@/constants/custom-headers/index";


export const validateCustomHeaderKey = (key) => {
	if (!key || key.trim().length === 0) {
		return CUSTOM_HEADER_ERROR_MESSAGES.CANNOT_BE_EMPTY_KEY;
	}

	const trimmedKey = key.trim();

	if (trimmedKey.length > MAX_HEADER_KEY_LENGTH) {
		return CUSTOM_HEADER_ERROR_MESSAGES.KEY_TOO_LONG;
	}

	const validFormatRegex = /^[A-Za-z0-9_-]+$/;
	if (!validFormatRegex.test(trimmedKey)) {
		return CUSTOM_HEADER_ERROR_MESSAGES.INVALID_KEY_FORMAT;
	}

	if (RESERVED_HEADERS.includes(trimmedKey.toLowerCase())) {
		return CUSTOM_HEADER_ERROR_MESSAGES.RESERVED_HEADER;
	}

	return null;
};

export const validateCustomHeaderValue = (value) => {
	if (!value || value.trim().length === 0) {
		return CUSTOM_HEADER_ERROR_MESSAGES.CANNOT_BE_EMPTY_VALUE;
	}

	if (value.includes("\r") || value.includes("\n") || value.includes("\\r") || value.includes("\\n")) {
		return CUSTOM_HEADER_ERROR_MESSAGES.VALUE_HAS_NEWLINE;
	}

	const trimmedValue = value.trim();
	if (trimmedValue.length > MAX_HEADER_VALUE_LENGTH) {
		return CUSTOM_HEADER_ERROR_MESSAGES.VALUE_TOO_LONG;
	}

	return null;
};
